import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type { HotelAndMarketServiceWithMarket } from 'lumen/services/hotel-and-market';
import { FEATURE_TOGGLES } from 'lumen/utils/constants/feature-toggle-constants';
import protectedRoute from 'lumen/utils/decorators/protected-route';
import { fetchDataStatuses } from 'lumen/utils/market-snapshots/query';

// @ts-expect-error: Unable to resolve signature of class decorator when called as an expression.
@protectedRoute({
  features: ['app.market.reservations'],
  featureToggles: FEATURE_TOGGLES.BI_SNAPSHOTS,
})
export default class MarketSnapshotsRoute extends Route {
  @service declare errorTracking: Services['error-tracking'];
  @service('hotel-and-market')
  declare hotelAndMarketService: HotelAndMarketServiceWithMarket;
  @service declare store: Services['store'];

  model(): void {
    // Fetched here, not in the view routes: those refresh on every query param
    // change, while a market's statuses cover all its subscriptions on any page.
    void fetchDataStatuses(
      { errorTracking: this.errorTracking, store: this.store },
      this.hotelAndMarketService.market.id!,
    );
  }
}
